import { Identifiable, Unavailability } from "@planzone/dto";
import { Filter } from "@planzone/dto";

function isFilteredByResources(
  { resource }: Identifiable<Unavailability>,
  { resources }: Filter,
) {
  return (
    !!resources &&
    resources.length > 0 &&
    !resources.find((res) => res.uuid === resource.uuid)
  );
}

export { isFilteredByResources };
